<!--<ngx-loading-bar></ngx-loading-bar>-->
<paywall-host></paywall-host>
<router-outlet></router-outlet>
